(function () {
  /* ═══════════════════════════════════════════════════════════════
     Shop the Look – LEGACY Single-AddOn-Modal
     Wird geladen wenn nur custom.shop_the_look_product gepflegt ist
     (das alte Metafield) und das neue shop_the_look_multiple leer.
     ═══════════════════════════════════════════════════════════════ */
  var MODAL_SEL = "#shopLookModal";
  var CONTENT_SEL = "#shopLookContent";
  var CONFIG_SEL = "#stl-config-legacy";
  var SLIDER_SEL = ".product-images, product-slider, .flickity-slider";
  var BOOT_RETRY_MS = 250;

  var cfgEl = document.getElementById("stl-config-legacy");
  if (!cfgEl) return;

  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent); }
  catch (e) { console.error("Shop the Look (legacy): ungültige Config", e); return; }
  if (!cfg || !cfg.addOn) return;

  var DELIVERY_TIMES = cfg.lieferzeit || {};

  /* ── Helpers ─────────────────────────────────────────────── */
  function $(s, r) { return (r || document).querySelector(s); }
  function esc(s) {
    s = s == null ? "" : String(s);
    return s.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
  }
  function safeMoney(cents) {
    var n = Number(cents);
    if (!isFinite(n)) return "";
    return (n / 100).toFixed(2).replace(".", ",") + "€";
  }
  function calcSavingsPercent(price, compareAt) {
    var p = Number(price), c = Number(compareAt);
    if (!isFinite(p) || !isFinite(c) || c <= p || c <= 0) return null;
    return Math.round(((c - p) / c) * 100);
  }
  function formatDate(d) {
    var date = new Date(d);
    return isNaN(date) ? d : date.toLocaleDateString("de-DE");
  }

  /* ── Swatch-Farben aus Theme-DOM lesen ───────────────────── */
  function parseSwatchLabels(root) {
    var colors = {};
    var getById = root.getElementById ? root.getElementById.bind(root) : document.getElementById.bind(document);
    root.querySelectorAll("label.swatch").forEach(function (label) {
      var inputId = label.getAttribute("for");
      var input = inputId ? getById(inputId) : null;
      var name = input ? input.value : label.textContent.trim();
      if (!name || colors[name]) return;
      var style = label.getAttribute("style") || "";
      var hexMatch = style.match(/--option-color:\s*([^;]+)/);
      var imgMatch = style.match(/--option-color-image:\s*url\('([^']+)'\)/);
      colors[name] = {};
      if (hexMatch && hexMatch[1].trim() !== "var(--bg-body)") colors[name].hex = hexMatch[1].trim();
      if (imgMatch) colors[name].image = imgMatch[1];
    });
    return colors;
  }
  var swatchColors = parseSwatchLabels(document);

  function loadAddonSwatchColors(handle) {
    return fetch("/products/" + handle)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        var addonColors = parseSwatchLabels(doc);
        Object.keys(addonColors).forEach(function (n) {
          if (!swatchColors[n]) swatchColors[n] = addonColors[n];
        });
      })
      .catch(function () {});
  }
  loadAddonSwatchColors(cfg.addOn);

  function swatchStyle(name) {
    var c = swatchColors[name];
    if (!c) return "background:#ccc;";
    if (c.image) return "background-image:url('" + esc(c.image) + "');background-size:cover;";
    if (c.hex) return "background:" + esc(c.hex) + ";";
    return "background:#ccc;";
  }

  /* Body-Lock-State aufräumen (idempotent).
     Räumt NUR Body-Klassen + inline Scroll-Lock auf – Cart-App-Drawer-State
     wird NICHT angetastet, damit die App nach ATC ihren Drawer öffnen kann. */
  function unlockBody() {
    document.documentElement.classList.remove("modal-open");
    document.body.classList.remove("modal-open");
    document.body.classList.remove("ast-no-scroll");
    var top = document.body.style.top;
    var lockedY = top && top.indexOf("-") === 0 ? parseInt(top, 10) : 0;
    document.body.style.position = "";
    document.body.style.top = "";
    document.body.style.width = "";
    if (lockedY < 0) window.scrollTo(0, -lockedY);
  }

  /* ── Button-Injection (gleiche Strategie wie neues JS) ───── */
  var buttonHTML = '<button type="button" class="shop-the-look-btn">'
    + '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">'
    + '<mask id="mask0_legacy_stl" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16"><rect width="16" height="16" fill="#D9D9D9"></rect></mask>'
    + '<g mask="url(#mask0_legacy_stl)"><path d="M8.00301 10.1025C8.68045 10.1025 9.25529 9.86538 9.72751 9.39116C10.1997 8.91694 10.4358 8.34111 10.4358 7.66366C10.4358 6.98622 10.1987 6.41138 9.72451 5.93916C9.25029 5.46694 8.67445 5.23083 7.99701 5.23083C7.31956 5.23083 6.74473 5.46794 6.27251 5.94216C5.80029 6.41638 5.56417 6.99222 5.56417 7.66966C5.56417 8.34711 5.80129 8.92194 6.27551 9.39416C6.74973 9.86638 7.32556 10.1025 8.00301 10.1025ZM8.00001 9.46666C7.50001 9.46666 7.07501 9.29166 6.72501 8.94166C6.37501 8.59166 6.20001 8.16666 6.20001 7.66666C6.20001 7.16666 6.37501 6.74166 6.72501 6.39166C7.07501 6.04166 7.50001 5.86666 8.00001 5.86666C8.50001 5.86666 8.92501 6.04166 9.27501 6.39166C9.62501 6.74166 9.80001 7.16666 9.80001 7.66666C9.80001 8.16666 9.62501 8.59166 9.27501 8.94166C8.92501 9.29166 8.50001 9.46666 8.00001 9.46666ZM8.00184 12C6.55784 12 5.24184 11.6071 4.05384 10.8212C2.86584 10.0353 1.97612 8.98377 1.38467 7.66666C1.97612 6.34955 2.86523 5.29805 4.05201 4.51216C5.23879 3.72627 6.55417 3.33333 7.99817 3.33333C9.44217 3.33333 10.7582 3.72627 11.9462 4.51216C13.1342 5.29805 14.0239 6.34955 14.6153 7.66666C14.0239 8.98377 13.1348 10.0353 11.948 10.8212C10.7612 11.6071 9.44584 12 8.00184 12ZM8.00001 11.3333C9.25556 11.3333 10.4083 11.0028 11.4583 10.3417C12.5083 9.68055 13.3111 8.78888 13.8667 7.66666C13.3111 6.54444 12.5083 5.65277 11.4583 4.99166C10.4083 4.33055 9.25556 3.99999 8.00001 3.99999C6.74445 3.99999 5.59167 4.33055 4.54167 4.99166C3.49167 5.65277 2.6889 6.54444 2.13334 7.66666C2.6889 8.78888 3.49167 9.68055 4.54167 10.3417C5.59167 11.0028 6.74445 11.3333 8.00001 11.3333Z" fill="#1C1B1F"></path></g>'
    + '</svg> Shop the Look</button>';

  function insertButtons() {
    var slides = document.querySelectorAll(
      ".flickity-slider > div, .product-images__slide, .product-media-item, .product-media-item__wrapper"
    );
    slides.forEach(function (slide) {
      if (!slide.querySelector("img") || slide.querySelector(".shop-the-look-btn")) return;
      if (getComputedStyle(slide).position === "static") slide.style.position = "relative";
      slide.insertAdjacentHTML("beforeend", buttonHTML);
    });
  }
  function watchSlider() {
    insertButtons();
    var slider = $(SLIDER_SEL);
    if (!slider) return setTimeout(watchSlider, BOOT_RETRY_MS);
    new MutationObserver(insertButtons).observe(slider, { childList: true, subtree: true });
  }
  watchSlider();

  /* ── Render-Helpers ──────────────────────────────────────── */
  function renderPriceHTML(v) {
    var pct = calcSavingsPercent(v.price, v.compare_at_price);
    if (v.compare_at_price && v.compare_at_price > v.price) {
      return '<p class="product-price">'
        + '<span class="compare-price">' + esc(safeMoney(v.compare_at_price)) + '</span>'
        + '<span class="current-price">' + esc(safeMoney(v.price)) + '</span>'
        + (pct ? '<span class="badge onsale">Spare ' + pct + '%</span>' : "")
        + '</p>';
    }
    return '<p class="product-price"><span class="current-price">' + esc(safeMoney(v.price)) + '</span></p>';
  }

  function renderLieferzeit(product, variant) {
    if (!variant) {
      return '<div class="ProductForm__NotAvailable_pulse"></div><span class="lieferbar-text-rot">Variante nicht verfügbar</span>';
    }
    if (!variant.available) {
      return '<div class="ProductForm__NotAvailable_pulse"></div><span class="lieferbar-text-rot">Ausverkauft, setze dich auf die Warteliste</span>';
    }
    var preorderDate = variant.metafields && variant.metafields.custom && variant.metafields.custom.vorbestellung_datum;
    if (preorderDate) {
      return '<div class="ProductForm__PreOrder_pulse"></div>'
        + '<span class="lieferbar-text-orange">' + esc(DELIVERY_TIMES.vorbestellung_label || "") + " " + esc(formatDate(preorderDate)) + '</span>';
    }
    var txt = DELIVERY_TIMES.lieferzeit_1 || "";
    if (product.tags && product.tags.indexOf("lieferzeit_2") > -1) txt = DELIVERY_TIMES.lieferzeit_2 || txt;
    if (product.tags && product.tags.indexOf("lieferzeit_3") > -1) txt = DELIVERY_TIMES.lieferzeit_3 || txt;
    return '<div class="ProductForm__Available_pulse"></div><span class="lieferbar-text-gruen">' + esc(txt) + '</span>';
  }

  function updateATC(v) {
    var btn = document.getElementById("modal-atc-btn");
    if (!btn) return;
    if (!v || !v.available) {
      btn.textContent = "AUSVERKAUFT";
      btn.classList.add("is-disabled");
      btn.disabled = true;
      return;
    }
    btn.textContent = "IN DEN WARENKORB";
    btn.classList.remove("is-disabled");
    btn.disabled = false;
  }

  /* ── State + Render ──────────────────────────────────────── */
  var productData = null;
  var selectedVariantId = null;

  function renderModal(content, p, v) {
    productData = p;
    selectedVariantId = v.id;

    var images = p.images.map(function (img, idx) {
      var badge = idx === 0
        ? '<span class="product-card--badges top left"><span class="badge onsale">Meist gekauft</span></span>'
        : "";
      return '<div class="slider-image-wrapper">' + badge + '<img class="slider-image" src="' + esc(img) + '"></div>';
    }).join("");

    var optionsHTML = p.options.map(function (opt, idx) {
      var name = typeof opt === "object" ? opt.name : opt;
      var isColor = /color|farbe|colour/i.test(name);
      var values = [];
      var seen = {};
      p.variants.forEach(function (va) {
        var val = va.options[idx];
        if (!seen[val]) { seen[val] = true; values.push(val); }
      });

      var optsHTML = values.map(function (val, i) {
        if (isColor) {
          return '<label class="swatch color' + (i === 0 ? " active" : "") + '">'
            + '<input type="radio" name="opt-' + idx + '" value="' + esc(val) + '"' + (i === 0 ? " checked" : "") + '>'
            + '<span style="' + swatchStyle(val) + '"></span></label>';
        }
        return '<label class="variant-btn' + (i === 0 ? " active" : "") + '">'
          + '<input type="radio" name="opt-' + idx + '" value="' + esc(val) + '"' + (i === 0 ? " checked" : "") + '>'
          + '<span>' + esc(val) + '</span></label>';
      }).join("");

      return '<div class="variant-block">'
        + '<div class="variant-label">' + esc(name) + ": " + esc(values[0]) + '</div>'
        + '<div class="' + (isColor ? "swatches" : "variant-buttons") + '" data-index="' + idx + '">'
        + optsHTML
        + '</div></div>';
    }).join("");

    content.innerHTML =
      '<div class="slider-wrapper">' + images + '</div>'
      + '<h2 class="modal-product-title"><a href="' + esc(p.url) + '" target="_self">' + esc(p.title) + '</a></h2>'
      + renderPriceHTML(v)
      + optionsHTML
      + '<div id="modal-delivery-info" class="custom-lieferzeit"></div>'
      + '<button class="add-to-cart-btn" id="modal-atc-btn">IN DEN WARENKORB</button>';

    document.getElementById("modal-delivery-info").innerHTML = renderLieferzeit(p, v);
    updateATC(v);
  }

  /* ── OPEN MODAL ──────────────────────────────────────────── */
  document.addEventListener("click", function (e) {
    if (!e.target.closest(".shop-the-look-btn")) return;
    e.stopImmediatePropagation();
    e.preventDefault();

    var modal = $(MODAL_SEL);
    var content = $(CONTENT_SEL);
    if (!modal || !content) return;

    modal.classList.add("active");
    content.innerHTML = '<div class="stl-legacy-loader">Lädt…</div>';

    fetch("/products/" + cfg.addOn + ".js")
      .then(function (r) { return r.json(); })
      .then(function (p) {
        var v = p.variants.find(function (x) { return x.available; }) || p.variants[0];
        renderModal(content, p, v);
      })
      .catch(function (err) {
        console.error("Shop the Look (legacy): Produkt konnte nicht geladen werden", err);
        content.innerHTML = "";
      });
  });

  /* ── VARIANT CHANGE ──────────────────────────────────────── */
  document.addEventListener("change", function (e) {
    if (!e.target.matches('input[type="radio"]')) return;
    var content = $(CONTENT_SEL);
    if (!content || !productData) return;

    var wrapper = e.target.closest(".swatches, .variant-buttons");
    if (wrapper) {
      wrapper.querySelectorAll("label").forEach(function (l) { l.classList.remove("active"); });
      e.target.closest("label").classList.add("active");
    }

    var selected = [];
    content.querySelectorAll("[data-index]").forEach(function (g, i) {
      var checked = g.querySelector("input:checked");
      if (checked) selected[i] = checked.value;
    });

    var v = productData.variants.find(function (x) {
      return x.options.every(function (o, i) { return o === selected[i]; });
    });
    if (!v) return;

    selectedVariantId = v.id;
    var priceEl = content.querySelector(".product-price");
    if (priceEl) priceEl.outerHTML = renderPriceHTML(v);
    updateATC(v);
    var deliveryEl = document.getElementById("modal-delivery-info");
    if (deliveryEl) deliveryEl.innerHTML = renderLieferzeit(productData, v);

    content.querySelectorAll(".variant-block").forEach(function (block, i) {
      var label = block.querySelector(".variant-label");
      if (!label) return;
      var name = productData.options[i];
      if (typeof name === "object") name = name.name;
      label.textContent = name + ": " + selected[i];
    });

    if (v.featured_image) {
      var slider = content.querySelector(".slider-wrapper");
      var srcKey = v.featured_image.src.split("?")[0];
      slider.querySelectorAll(".slider-image").forEach(function (img) {
        if (img.src.indexOf(srcKey) > -1) {
          var w = img.closest(".slider-image-wrapper");
          if (w) slider.scrollTo({ left: w.offsetLeft, behavior: "smooth" });
        }
      });
    }
  });

  /* ── ADD TO CART ─────────────────────────────────────────── */
  document.addEventListener("click", function (e) {
    var btn = e.target.closest(".add-to-cart-btn");
    if (!btn || btn.disabled) return;
    btn.disabled = true;
    btn.classList.add("is-loading");

    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: selectedVariantId, quantity: 1 }),
    })
    .then(function (res) {
      if (!res.ok) throw new Error("ATC failed");
      return res.json();
    })
    .then(function (item) {
      document.dispatchEvent(new CustomEvent("cart:updated", { detail: item }));
      var modal = $(MODAL_SEL);
      if (modal) modal.classList.remove("active");
      // Frame-JS feuert nicht bei programmatischem Close → selbst aufräumen
      unlockBody();
    })
    .catch(function (err) {
      console.error("Shop the Look (legacy): ATC fehlgeschlagen", err);
      alert("Artikel konnte nicht in den Warenkorb gelegt werden. Bitte erneut versuchen.");
    })
    .finally(function () {
      btn.disabled = false;
      btn.classList.remove("is-loading");
    });
  });
})();
